import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { clock, HOUR_MS } from "clock";
import blinkenlights from "blinkenlights";
var OtDeviceInfo = /** @class */ (function (_super) {
    tslib_1.__extends(OtDeviceInfo, _super);
    function OtDeviceInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OtDeviceInfo.prototype.watchCurrentEvent = function (ev) {
        console.log("watchCurrentEvent " + !!ev);
        if (this.controlLights)
            blinkenlights.set(ev ? { r: 255, g: 0, b: 0 } : { r: 0, g: 255, b: 0 });
    };
    Object.defineProperty(OtDeviceInfo.prototype, "todayEvents", {
        get: function () {
            return (this.calendar.events || []).filter(function (e) { return e.start >= clock.today && e.end.getTime() <= (clock.today.getTime() + 24 * HOUR_MS); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OtDeviceInfo.prototype, "eventStatus", {
        get: function () {
            var e_1, _a;
            var now = clock.nowMinute;
            var currentEvent = null;
            var seriesCount = 0, seriesEnd = null;
            try {
                for (var _b = tslib_1.__values(this.todayEvents), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var ev = _c.value;
                    if (ev.start <= now && now <= ev.end
                        || (seriesEnd && ev.start.getTime() <= seriesEnd.getTime())) {
                        seriesCount++;
                        if (!seriesEnd || ev.end > seriesEnd)
                            seriesEnd = ev.end;
                        if (!currentEvent)
                            currentEvent = ev;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (currentEvent) {
                return {
                    currentEvent: currentEvent,
                    seriesEnd: seriesEnd,
                    seriesCount: seriesCount,
                };
            }
            var nextEvent = this.todayEvents.find(function (ev) { return ev.start >= now; });
            return {
                currentEvent: null,
                nextEvent: nextEvent,
            };
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], OtDeviceInfo.prototype, "calendar", void 0);
    tslib_1.__decorate([
        Prop({ default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], OtDeviceInfo.prototype, "controlLights", void 0);
    tslib_1.__decorate([
        Watch("eventStatus.currentEvent", { immediate: true }),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], OtDeviceInfo.prototype, "watchCurrentEvent", null);
    OtDeviceInfo = tslib_1.__decorate([
        Component
    ], OtDeviceInfo);
    return OtDeviceInfo;
}(Vue));
export default OtDeviceInfo;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/OtCalendar.vue
// module id = 220
// module chunks = 0